import React, { MouseEvent, Fragment } from "react";
import { Theme } from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Popover from "@material-ui/core/Popover";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { ProfileCard } from "../../ProfileCard";
import { Icon } from "../../icons/Icon";
import { IconButton } from "../../inputs/IconButton";
import {
  backgroundImageUrl,
  MedsafeCondensedLogo
} from "../../../assets/images";
import { User } from "../../../constants/interfaces";

type Props = {
  classes?: any;
  onMenuPress?: () => void;
  user?: User;
};

type State = {
  profileMenuOpen: boolean;
  profileMenuAnchor: HTMLElement | null;
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      backgroundImage: `url(${backgroundImageUrl})`
    },
    logoWrapper: {
      alignItems: "center",
      display: "flex",
      flexGrow: 1,
      justifyContent: "center"
    },
    icon: {
      color: theme.palette.common.white
    },
    profileWrapper: {
      padding: theme.spacing(2)
    }
  });

class TopBar extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      profileMenuAnchor: null,
      profileMenuOpen: false
    };
    this.closeProfileMenu = this.closeProfileMenu.bind(this);
    this.toggleProfileMenu = this.toggleProfileMenu.bind(this);
  }

  toggleProfileMenu(e: MouseEvent<HTMLButtonElement>) {
    const target = e.currentTarget;
    this.setState(prevState => ({
      profileMenuAnchor: target,
      profileMenuOpen: !prevState.profileMenuOpen
    }));
  }

  closeProfileMenu() {
    this.setState({
      profileMenuAnchor: null,
      profileMenuOpen: false
    });
  }

  render() {
    const { classes, onMenuPress, user } = this.props;
    const { profileMenuAnchor, profileMenuOpen } = this.state;

    const profilePopperId = profileMenuOpen ? "profile-popper" : undefined;

    // Only show the icons if the user is authenticated

    return (
      <AppBar
        classes={{
          root: classes.root
        }}
        position="static"
        color="inherit"
      >
        <Toolbar>
          {user && onMenuPress && (
            <IconButton aria-label="Menu" id="menu" onClick={onMenuPress}>
              <Icon className={classes.icon} name="menu" />
            </IconButton>
          )}
          <div className={classes.logoWrapper}>
            <MedsafeCondensedLogo id="mcols-condensed-logo" />
          </div>
          {user && (
            <Fragment>
              <IconButton
                aria-describedby={profilePopperId}
                aria-haspopup="true"
                id="profile"
                onClick={this.toggleProfileMenu}
              >
                <Icon className={classes.icon} name="persons" />
              </IconButton>
              <Popover
                anchorEl={profileMenuAnchor}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left"
                }}
                id={profilePopperId}
                open={profileMenuOpen}
                onClose={this.toggleProfileMenu}
              >
                <div className={classes.profileWrapper}>
                  <ProfileCard
                    onLogoutClick={this.closeProfileMenu}
                    onProfileClick={this.closeProfileMenu}
                    user={user}
                  />
                </div>
              </Popover>
            </Fragment>
          )}
        </Toolbar>
      </AppBar>
    );
  }
}

export default withStyles(styles)(TopBar);
